import { cn } from "@aircall/ds";

import {
  RenderMultipleDirection,
  RenderMultipleProps,
} from "./RenderMultiple.decl";

const DIRECTION_CLASS: Record<RenderMultipleDirection, string> = {
  horizontal: "flex-row",
  vertical: "flex-col",
};

export function RenderMultiple({
  children,
  quantity,
  direction = "vertical",
  className,
  ...rest
}: RenderMultipleProps) {
  const items = Array(quantity).fill(undefined);

  return (
    <div
      {...rest}
      className={cn("flex", DIRECTION_CLASS[direction], className)}
    >
      {items.map((_, index) => children(index))}
    </div>
  );
}
